import axios from 'axios'
import { config, configMultipart, url } from '../../index'
import { centrifugePublish, centrifugeSubscribe } from '@/api/centrifuge'
import { clearUserHtml, debounce, formatDateForServer } from '@/utils/utils'
import usersApi from '@/api/usersApi'
// import moment from 'moment'

// дата без времени, много где используется сравнение дат
const getDate = (date) => {
  return date.slice(0, 10)
}
const parseMessages = (messageArray) => {
  const parsedArray = []

  for (let i = 0; i < messageArray.length; i++) {
    // нужно проставить в массив сообщений разделители по датам
    // для сравнения дат берем только дату без времени это первые 10 символов
    const currentMessageDate = new Date(getDate(messageArray[i].created_at))
    const nextMessageDate = messageArray[i + 1] ? new Date(getDate(messageArray[i + 1].created_at)) : false

    if (nextMessageDate && (currentMessageDate > nextMessageDate)) {
      parsedArray.push({
        ...messageArray[i],
        tags: messageArray[i].tags ? messageArray[i].tags : [],
        attachments: messageArray[i].attachments ? messageArray[i].attachments : [],
        isControlsActive: false,
        is_dateBreaker: false
      })
      parsedArray.push({
        id: `${messageArray[i].id}_date-breaker`,
        date: messageArray[i].created_at,
        is_dateBreaker: true
      })
    } else {
      parsedArray.push({
        ...messageArray[i],
        tags: messageArray[i].tags ? messageArray[i].tags : [],
        attachments: messageArray[i].attachments ? messageArray[i].attachments : [],
        isControlsActive: false,
        is_dateBreaker: false
      })
    }
  }
  // нужно поместить еще один дата брейкер в самом начале диалога
  // иногда вторая страница подгружается сразу и возникает ошибка так как parsedArray[parsedArray.length - 1] == undefined
  if (parsedArray[parsedArray.length - 1]) {
    parsedArray.push({
      id: `${parsedArray[parsedArray.length - 1].id}_date-breaker`,
      date: parsedArray[parsedArray.length - 1].created_at,
      is_dateBreaker: true
    })
  }

  return parsedArray.reverse()
}
const updateDateBreakers = (originArray) => {
  let updatedArray = [...originArray]
  originArray.forEach((message, i, array) => {
    // dateBreaker удаляется если следующий за ним элемент тоже dateBreaker или после него больше нет элементов
    if (message.is_dateBreaker && ((array[i + 1] && array[i + 1].is_dateBreaker) || (array[i - 1] && getDate(array[i - 1].created_at) === getDate(message.date)) || !array[i + 1])) {
      updatedArray = originArray.filter(item => {
        return item.id !== message.id
      })
    }
  })
  return updatedArray
}

const state = () => ({
  active: false,
  counter: 0,
  currentDialog: null,
  dialogRoomList: {
    isLoading: true,
    searchValue: '',
    owner_id: null,
    // созданые чаты
    list: [],
    // список юзеров для создания приватных чатов
    userList: [],
    userListPagination: {
      isBlocked: false,
      currentPage: 1
    }
  },
  dialogRoomModal: {
    active: false,
    updatedId: null,
    name: '',
    color: '#1170B8',
    members: [],
    admins: [],
    validation: {
      name: { type: null, message: '' },
      members: { type: null, message: '' }
    }
  },
  dialogDeleteModal: {
    active: false,
    deleteId: null
  },
  historyModal: {
    active: false,
    isLoading: true,
    filterDate: '',
    searchValue: '',
    originMessages: [],
    messages: []
  },
  pinnedModal: {
    active: false,
    message: null,
    owner: null,
    attachments: null,
    tags: null
  },
  messageArea: {
    updatedId: null,
    errorMessage: '',
    reply: {
      id: null,
      ownerId: null,
      quote: ''
    },
    message: '',
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    },
    resendMessages: []
  },
  sendMessageLoading: false,
  autoScroll: true,
  currentPage: 1,
  pageCount: null,
  nextPageIsLoading: false,
  debounce: null,
  dialogRoomLoading: false
})

const getters = {
  getDialogWidgetActive: state => state.active,
  getNewDialogCounter: state => state.counter,
  getCurrentDialog: state => state.currentDialog,
  getQuote: state => {
    return state.currentDialog.messages.find(item => item.id === state.messageArea.reply.id)
  },
  getUpdateMessage: state => {
    state.currentDialog.messages.find(item => item.id === state.messageArea.updatedId)
  },
  getDialogNextPageIsLoading: state => state.nextPageIsLoading,
  getPinnedMessage: state => state.currentDialog.pinnedMessage,
  getDialogMessagesWrapAutoScroll: state => state.autoScroll,
  // такой геттер нужен чтобы получать сообщения для watch в DialogWidget.vue только когда currentDialog != 0
  getDialogMessages: state => state.currentDialog ? state.currentDialog.messages : [],
  getDialogMessageArea: state => state.messageArea,
  getDialogRoomList: state => state.dialogRoomList,
  getDialogRoomModal: state => state.dialogRoomModal,
  getDialogDeleteModal: state => state.dialogDeleteModal,
  getDialogHistoryModal: state => state.historyModal,
  getDialogPinnedModal: state => state.pinnedModal,
  getDialogRoomLoading: state => state.dialogRoomLoading,
  getSendMessageLoading: state => state.sendMessageLoading,
  getSendButtonDisabled: state => {
    if (
      !state.messageArea.resendMessages.length &&
      !state.messageArea.message &&
      !state.messageArea.attachment.files.length
    ) {
      return true
    }
    return false
  }
}

const mutations = {
  SET_DEBOUNCE: (state, debounce) => {
    state.debounce = debounce
  },
  GET_DIALOG_LIST: (state, dialogList) => {
    state.dialogRoomList.isLoading = false
    state.dialogRoomList.list = dialogList.map(dialog => {
      return {
        ...dialog,
        name: dialog.name ? dialog.name : 'Без названия',
        color: dialog.color ? dialog.color : '#c4c4c4',
        counter: 0,
        is_group: dialog.type !== 1,
        is_active: false
      }
    })
  },
  UPDATE_DIALOG_WIDGET_COUNTER: state => {
    let sum = 0

    state.dialogRoomList.list.forEach(dialog => {
      sum += dialog.counter
    })
    state.counter = sum
  },
  SET_DIALOG_ROOM_COUNTER: (state, dataArray) => {
    dataArray.forEach(counterData => {
      state.dialogRoomList.list.find(room => room.id === counterData.roomId).counter = counterData.count
    })
  },
  RESET_DIALOG_ROOM_COUNTER: (state, data) => {
    state.dialogRoomList.list.forEach(dialog => {
      dialog.counter = dialog.id === data.roomId ? 0 : dialog.counter
    })
  },
  SET_DIALOG_WIDGET_USER_LIST: (state, userList) => {
    state.dialogRoomList.userList = userList
  },
  SET_DIALOG_WIDGET_USER_LIST_NEXT_PAGE: (state, userList) => {
    state.dialogRoomList.userList = state.dialogRoomList.userList.concat(userList)
  },
  SET_DIALOG_WIDGET_USER_LIST_PAGINATION: (state, headers) => {
    state.dialogRoomList.userListPagination.currentPage = +headers['x-pagination-current-page']
  },
  RESET_DIALOG_WIDGET_USER_LIST_CURRENT_PAGE: state => {
    state.dialogRoomList.userListPagination.currentPage = 1
  },
  SET_DIALOG_WIDGET_USER_LIST_PAGINATION_BLOCK: (state, flag) => {
    state.dialogRoomList.userListPagination.isBlocked = flag !== undefined ? flag : false
  },

  // модалка создать/редактировать
  SHOW_DIALOG_ROOM_MODAL: (state, roomId) => {
    const currentUserId = +localStorage.currentUserId

    state.dialogRoomModal.active = true
    state.dialogRoomModal.updatedId = roomId
    if (roomId) {
      state.dialogRoomModal.name = state.currentDialog.name
      state.dialogRoomModal.color = state.currentDialog.color
      // ToDo нужно убрать текущего пользователя (владельца комнаты) чтобы он не отображался в списке опций
      state.dialogRoomModal.members = state.currentDialog.users
        .map(user => {
          // console.log(user)
          return {
            id: user.id,
            name: user.profile_name,
            isActive: true
          }
        })
        .filter(user => user.id !== currentUserId)
    }
  },

  SHOW_DIALOG_DELETE_MODAL: (state, roomId) => {
    state.dialogDeleteModal.active = true
    state.dialogRoomModal.updatedId = roomId
  },

  CLOSE_DIALOG_DELETE_MODAL: (state) => {
    state.dialogDeleteModal.active = false
  },

  SET_DIALOG_ROOM_MODAL_NAME: (state, name) => {
    state.dialogRoomModal.name = name
  },
  SET_DIALOG_ROOM_MODAL_COLOR: (state, color) => {
    state.dialogRoomModal.color = color
  },
  ADD_DIALOG_ROOM_MODAL_MEMBER: (state, user) => {
    state.dialogRoomModal.members.push(user)
  },
  REMOVE_DIALOG_ROOM_MODAL_MEMBER: (state, user) => {
    state.dialogRoomModal.members = state.dialogRoomModal.members.filter(member => {
      return member.id !== user.id
    })
  },
  ADD_DIALOG_ROOM_MODAL_ADMIN: (state, user) => {
    state.dialogRoomModal.admins.push(user)
  },
  REMOVE_DIALOG_ROOM_MODAL_ADMIN: (state, user) => {
    state.dialogRoomModal.admins = state.dialogRoomModal.admins.filter(admin => {
      return admin.id !== user.id
    })
  },
  SET_DIALOG_ROOM_MODAL_VALIDATION: (state, errors) => {
    if (errors) {
      state.dialogRoomModal.validation.name = errors.name ? { type: 'error', message: errors.name[0] } : { type: null, message: '' }
      state.dialogRoomModal.validation.members = errors.user_ids ? { type: 'error', message: errors.user_ids[0] } : { type: null, message: '' }
    }
  },
  CLOSE_DIALOG_ROOM_MODAL: (state) => {
    state.dialogRoomModal.active = false
  },
  CLEAR_DIALOG_ROOM_MODAL_VALIDATION: (state) => {
    state.dialogRoomModal.validation.name = { type: null, message: '' }
    state.dialogRoomModal.validation.members = { type: null, message: '' }
  },
  // /модалка создать/редактировать

  // модалка истории сообщений
  SHOW_DIALOG_HISTORY_MODAL: (state) => {
    state.historyModal.active = true
  },
  GET_DIALOG_HISTORY_MODAL_MESSAGES: (state, messages) => {
    // отдельная мутация для загрузки сообщений сделана для того чтобы модалка открывалась быстро
    // а потом уже подгружались сообщения
    state.historyModal.isLoading = false
    state.historyModal.originMessages = parseMessages(messages)
    state.historyModal.messages = state.historyModal.originMessages
  },
  CLOSE_DIALOG_HISTORY_MODAL: (state) => {
    state.historyModal.active = false
    state.historyModal.isLoading = true
    state.historyModal.searchValue = ''
    state.historyModal.filterDate = ''
    state.historyModal.messages = []
  },
  SET_DIALOG_HISTORY_MODAL_SEARCH_VALUE: (state, value) => {
    state.historyModal.searchValue = value
    const originArray = state.historyModal.originMessages

    state.historyModal.messages = originArray.filter(message => {
      if (!message.is_dateBreaker) {
        const fileNames = message.attachments ? message.attachments.map(file => file.file_name).join() : ''
        const messageContent = message.message + fileNames
        return messageContent.indexOf(value) + 1
      }
    })
  },
  SET_DIALOG_HISTORY_MODAL_FILTER_DATE: (state, date) => {
    state.historyModal.filterDate = date
    const originArray = state.historyModal.originMessages

    state.historyModal.messages = originArray.filter(message => {
      const createdDate = !message.is_dateBreaker ? getDate(message.created_at) : null
      return createdDate === date
    })
  },
  CLEAR_DIALOG_HISTORY_MODAL_FILTER: (state) => {
    state.historyModal.searchValue = ''
    state.historyModal.filterDate = ''

    state.historyModal.messages = state.historyModal.originMessages
  },
  // /модалка истории сообщений

  // модалка истории сообщений
  SHOW_DIALOG_PINNED_MODAL: (state) => {
    const modal = state.pinnedModal
    const pinnedMessage = state.currentDialog.pinned_message

    modal.active = true
    modal.message = pinnedMessage.message
    modal.attachments = pinnedMessage.attachments
  },
  CLOSE_DIALOG_PINNED_MODAL: (state) => {
    const modal = state.pinnedModal

    modal.active = false
    modal.message = null
    modal.attachments = null
  },
  // /модалка истории сообщений

  TOGGLE_ASIDE_DIALOG_WIDGET: (state) => {
    state.active = !state.active
  },
  OPEN_ASIDE_DIALOG_WIDGET: (state) => {
    state.active = true
  },
  CLOSE_ASIDE_DIALOG_WIDGET: (state) => {
    state.active = false
  },
  TOGGLE_CURRENT_DIALOG_CONTROLS: (state) => {
    state.currentDialog.isControlsActive = !state.currentDialog.isControlsActive
  },
  CLOSE_CURRENT_DIALOG_CONTROLS: (state) => {
    if (state.currentDialog) {
      state.currentDialog.isControlsActive = false
    }
  },
  TOGGLE_DIALOG_MESSAGE_CONTROLS: (state, messageId) => {
    state.currentDialog.messages.forEach((elem) => {
      if (messageId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (messageId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  CLOSE_DIALOG_MESSAGE_CONTROLS: (state) => {
    if (state.currentDialog) {
      state.currentDialog.messages.forEach((elem) => {
        elem.isControlsActive = false
      })
    }
  },
  SET_DIALOG_MESSAGE_VALUE: (state, message) => {
    state.messageArea.message = message
  },
  DIALOG_MESSAGE_ATTACH_FILES: (state, files) => {
    const newFiles = Object.values(files)
    state.messageArea.attachment.files = state.messageArea.attachment.files.concat(newFiles)
  },
  DIALOG_MESSAGE_REMOVE_FILE: (state, data) => {
    // из data берем индекс, потому что удаляем из вложений при создании сообщения, id у этих файлов нет
    // id файла нужно для удаление с сервера
    const files = state.messageArea.attachment.files
    files.splice(data.index, 1)
    state.messageArea.attachment.files = files
    // id файлов пушим в массив для последующего удаления с сервера (id есть только если сообщение редактируется)
    if (data.id !== undefined) {
      state.messageArea.attachment.filesToRemove.push(data.id)
    }
  },
  TOGGLE_DIALOG_MESSAGE_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.active = !state.messageArea.attachment.linkTooltip.active
  },
  CLOSE_DIALOG_MESSAGE_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.linkTooltip.text = ''
    state.messageArea.attachment.linkTooltip.url = ''
    state.messageArea.attachment.linkTooltip.active = false
  },
  SET_DIALOG_MESSAGE_LINK_TEXT: (state, text) => {
    state.messageArea.attachment.linkTooltip.text = text
  },
  SET_DIALOG_MESSAGE_LINK_URL: (state, url) => {
    state.messageArea.attachment.linkTooltip.url = url
  },
  SET_DIALOG_MESSAGE_LINK_TEXT_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.textValid = valid
  },
  SET_DIALOG_MESSAGE_LINK_URL_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.urlValid = valid
  },
  TOGGLE_DIALOG_MESSAGE_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.active = !state.messageArea.attachment.tagTooltip.active
  },
  CLOSE_DIALOG_MESSAGE_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.valid = {}
    state.messageArea.attachment.tagTooltip.text = ''
    state.messageArea.attachment.tagTooltip.active = false
  },
  SET_DIALOG_MESSAGE_TAG_TEXT: (state, text) => {
    state.messageArea.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  DIALOG_MESSAGE_ATTACH_TAG: (state) => {
    const tagText = state.messageArea.attachment.tagTooltip.text
    state.messageArea.attachment.tags.push(tagText)
  },
  DIALOG_MESSAGE_REMOVE_TAG: (state, index) => {
    const tags = [...state.messageArea.attachment.tags]
    tags.splice(index, 1)
    state.messageArea.attachment.tags = tags
  },
  SET_DIALOG_MESSAGE_REPLY: (state, replyData) => {
    state.messageArea.reply.id = replyData.id
    state.messageArea.reply.ownerId = replyData.ownerId
    state.messageArea.reply.quote = replyData.quote
  },
  REMOVE_DIALOG_MESSAGE_REPLY: (state) => {
    state.messageArea.reply.id = null
    state.messageArea.reply.ownerId = null
    state.messageArea.reply.quote = ''
  },
  SET_DIALOG_MESSAGE_TAG_VALID: (state, valid) => {
    state.messageArea.attachment.tagTooltip.valid = valid
  },
  CLEAR_DIALOG_MESSAGE_ATTACHMENT_VALID: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.tagTooltip.valid = {}
  },
  CLEAR_DIALOG_MESSAGE_AREA: (state) => {
    state.messageArea.updatedId = null
    state.messageArea.errorMessage = ''
    state.messageArea.reply.id = null
    state.messageArea.reply.userName = ''
    state.messageArea.reply.quote = ''
    state.messageArea.message = ''
    state.messageArea.attachment.files = []
    state.messageArea.attachment.tags = []
    state.messageArea.attachment.filesToRemove = []
    state.messageArea.resendMessages = []
  },
  CLEAR_DIALOG_MESSAGE_AREA_ERROR: (state) => {
    state.messageArea.errorMessage = ''
  },
  SET_DIALOG_MESSAGE_AREA_ERROR: (state, errors) => {
    if (errors.message) {
      state.messageArea.errorMessage = errors.message[0]
    }
  },
  SET_ACTIVE_DIALOG_ROOM: (state, dialog) => {
    state.dialogRoomList.list.forEach((elem) => {
      elem.is_active = elem.id === dialog.id
    })

    state.currentDialog = {
      ...dialog,
      name: dialog.name ? dialog.name : 'Без названия',
      color: dialog.color ? dialog.color : '#9DCBEE',
      isControlsActive: false,
      messages: [],
      whoPrintsId: null,
      messagesIsLoading: true,
      is_group: dialog.type !== 1
    }
  },
  EXPAND_ACTIVE_DIALOG_PINNED_MESSAGE: (state, message) => {
    state.currentDialog.pinned_message = {
      ...state.currentDialog.pinned_message,
      attachments: message.attachments,
      owner: message.owner
    }
  },
  UPDATE_ACTIVE_DIALOG_INFO: (state, roomId) => {
    const updatedDialog = state.dialogRoomList.list.filter(dialog => dialog.id === roomId).pop()
    state.currentDialog.name = updatedDialog.name
    state.currentDialog.color = updatedDialog.color
    state.currentDialog.users = updatedDialog.users
  },
  REMOVE_ACTIVE_DIALOG_ROOM: (state) => {
    state.dialogRoomList.list.forEach((elem) => {
      elem.is_active = false
    })
    state.currentDialog = null
  },
  TOGGLE_DIALOG_WHO_PRINTS: (state, userId) => {
    state.currentDialog.whoPrintsId = userId

    if (state.currentDialog.whoPrintsId) {
      setTimeout(() => {
        state.currentDialog.whoPrintsId = null
      }, 2000)
    }
  },

  // сообщения
  GET_DIALOG_ROOM_MESSAGE_LIST: (state, messageList) => {
    state.currentDialog.messages = parseMessages(messageList)
    state.currentDialog.messagesIsLoading = false
  },
  ADD_MESSAGE_BEFORE_SEND: (state, data) => {
    if (state.messageArea.updatedId) {
      state.currentDialog.messages = state.currentDialog.messages.map(item => {
        if (item.id === state.messageArea.updatedId) {
          return {
            ...item,
            attachments: data.attachments,
            updated_at: formatDateForServer(new Date()),
            isSending: true,
            message: data.message,
            quote: data.quote,
            status: 2,
            tags: data.tags
          }
        }
        return item
      })
    } else {
      state.currentDialog.messages.push(data)
    }
  },
  GET_DIALOG_ROOM_MESSAGE_LIST_NEXT_PAGE: (state, messageList) => {
    /* помещаем новые сообщения наверх диалога */
    state.currentDialog.messages = parseMessages(messageList).concat(state.currentDialog.messages)
    state.nextPageIsLoading = false
  },
  SET_DIALOG_ROOM_NEXT_PAGE_IS_LOADING: (state) => {
    state.nextPageIsLoading = true
  },
  PIN_DIALOG_ROOM_MESSAGE: (state, message) => {
    state.currentDialog.pinned_message = message
  },
  UNPIN_DIALOG_ROOM_MESSAGE: (state) => {
    state.currentDialog.pinned_message = null
  },
  GET_DIALOG_MESSAGE_FOR_UPDATE: (state, message) => {
    const resendsStartIndex = message.message?.indexOf('<div')
    const resendMessages = []
    let messageTrim = message.message

    if (resendsStartIndex && resendsStartIndex !== -1 && resendsStartIndex !== undefined) {
      const resendTrim = message.message.substring(resendsStartIndex)
      const parser = new DOMParser().parseFromString(resendTrim, 'text/html').body
      const parserCollection = parser.querySelector('div').children

      parserCollection.forEach(item => {
        const name = item.querySelector('b')?.textContent || ''
        const date = item.querySelector('small')?.textContent || ''
        const text = item.querySelector('div')?.innerHTML || ''

        resendMessages.push({
          owner: { name },
          created_at: date,
          message: text
        })
      })
      messageTrim = message.message.substring(0, resendsStartIndex)
    }

    state.messageArea.updatedId = message.id
    state.messageArea.reply.id = message.quote ? message.quote.id : null
    state.messageArea.reply.ownerId = message.quote ? message.quote.owner.id : null
    state.messageArea.reply.quote = message.quote ? message.quote.message : null
    state.messageArea.message = messageTrim
    state.messageArea.resendMessages = resendMessages
    state.messageArea.attachment.tags = message.tags
    state.messageArea.attachment.files = message.attachments
  },
  SET_DIALOG_MESSAGES_IS_READ: (state, updateData) => {
    if (state.currentDialog.id === updateData.roomId) {
      updateData.messageIds.forEach(messageId => {
        state.currentDialog.messages.find((message) => {
          return message.id === messageId
        }).is_read = true
      })
    }
  },
  UPDATE_DIALOG_ROOM_MESSAGE: (state, updatedMessage) => {
    const targetMessage = state.currentDialog.messages.find(message => message.id === updatedMessage.id)
    if (targetMessage) {
      targetMessage.quote = updatedMessage.quote
      targetMessage.message = updatedMessage.message
      targetMessage.attachments = updatedMessage.attachments ? updatedMessage.attachments : []
      targetMessage.tags = updatedMessage.tags ? updatedMessage.tags : []
      targetMessage.updated_at = updatedMessage.updated_at
      targetMessage.isSending = false
    }
    // если отредактированное сообщение закреплено, то обновляем закрепленное
    if (state.currentDialog.pinned_message?.id === updatedMessage.id) {
      const pinnedMessage = state.currentDialog.pinned_message

      pinnedMessage.message = updatedMessage.message
      pinnedMessage.attachments = updatedMessage.attachments ? updatedMessage.attachments : null
      pinnedMessage.tags = updatedMessage.tags ? updatedMessage.tags : []
    }
  },
  REMOVE_DIALOG_MESSAGE: (state, messageId) => {
    const messages = state.currentDialog.messages

    state.currentDialog.messages = messages.filter(message => {
      return message.id !== messageId
    })

    if (state.currentDialog && messageId === state.currentDialog.pinned_message?.id) {
      state.currentDialog.pinned_message = null
    }
  },
  // пересчет dateBreaker вынесено в отдельную мутацию для последовательности
  UPDATE_DIALOG_DATE_BREAKERS: (state) => {
    state.currentDialog.messages = updateDateBreakers(state.currentDialog.messages)
  },

  // пагинация, прокрутка
  SET_DIALOG_ROOM_MESSAGE_LIST_PAGINATION: (state, paginationData) => {
    state.currentPage = paginationData.currentPage
    state.pageCount = paginationData.pageCount
  },
  SET_DIALOG_MESSAGES_WRAP_AUTO_SCROLL: (state, flag) => {
    state.autoScroll = flag
  },

  // Search
  SET_DIALOG_LIST_SEARCH_VALUE: (state, value) => {
    state.dialogRoomList.searchValue = value
  },

  SET_DIALOG_RESEND_MESSAGES: (state, messages) => {
    state.messageArea.reply.id = null
    state.messageArea.reply.ownerId = null
    state.messageArea.reply.quote = null
    state.messageArea.resendMessages = messages
  },

  SET_DIALOG_ROOM_LOADING: (state, loading) => {
    state.dialogRoomLoading = loading
  },

  SET_SEND_MESSAGE_LOADING: (state, loading) => {
    state.sendMessageLoading = loading
  }
}

const actions = {
  getDialogRoomList (context, data) {
    // промис нужен для того чтобы запускать установку счетчиков после обновления списка комнат (в api/centrifuge.js)
    return new Promise(resolve => {
      // needSubscribe - не во всех случаях нужно переподписываться на каналы (например удаление, поиск)
      const sort = 'sort=-updated_at' // при создании сообщения у комнаты обновляется updated_at
      // TODO: вернуть фильтрацию когда будет понятно каким образом фильровать и групповые чаты и привытные(имя одинаковое). Расскомментить экшон в поиске
      const searchFilter = context.state.dialogRoomList.searchValue ? `search[name]=${context.state.dialogRoomList.searchValue}` : ''
      const expands = 'expand=users,last_message,unread,admins'

      axios.get(`${url}/chat/rooms?${expands}&${searchFilter}&${sort}&per-page=99999`, config).then(response => {
        const roomList = response.data.data.map(room => {
          return {
            lastMessage: room.last_message && room.last_message[0] && room.last_message[0].message ? clearUserHtml(room.last_message[0].message, true) : '',
            ...room
          }
        })
        const roomsCounterData = response.data.data.map(room => {
          return {
            roomId: room.id,
            count: room.unread
          }
        })

        context.commit('GET_DIALOG_LIST', roomList)
        context.commit('SET_DIALOG_ROOM_COUNTER', roomsCounterData)
        context.dispatch('getDialogUserList')
        resolve('success')

        if (data.needSubscribe) {
          const channelList = roomList.map(room => {
            return room.channel
          })
          channelList.forEach(channel => {
            // контекст передаем для того чтобы внутри subscribe можно было вызвать dispatch и commit
            centrifugeSubscribe(channel, context)
          })
        }
        // если экшон был вызван с флагом, который обозначает что какая-то комната была отредактирована
        if (data.updateCurrent) {
          const newListHasCurrent = roomList.find(dialog => {
            return dialog.id === data.updateCurrent
          })

          // если диалог из которого удалили текущего юзера был активный, то убираем его
          if (!newListHasCurrent) {
            context.commit('REMOVE_ACTIVE_DIALOG_ROOM')
          }
          // если диалог, который был отредактирован установлен как текущий, то обновляем его инфо
          if (context.state.currentDialog && data.updateCurrent === context.state.currentDialog.id) {
            context.commit('UPDATE_ACTIVE_DIALOG_INFO', data.updateCurrent)
          }
        }
      }).catch(error => {
        console.log('Ошибка получения списка диалогов', error)
      })
    })
  },
  getDialogRoomMessageList ({ commit }, roomId) {
    const sort = 'sort=-id'
    const expands = 'expand=owner,room,attachments,quote,readers,forwarded_messages'
    const filter = `search[room_id]=${roomId}`

    axios.get(`${url}/chat/messages?${sort}&${expands}&${filter}`, config).then(response => {
      // нужно пройтись по полученным сообщениям и если есть quote (сообщение на которое отвечали)
      // то запросить его по id, чтобы получить owner. owner нужен для вывода в сообщении его фио
      // проходка по массиву должна быть ассинхронной, иначе сообщения уже отрисуются прежде чем будет получен ответ от сервера
      const messageList = []
      async function processMessages (array) {
        for (const item of array) {
          if (item.quote) {
            const parentMessage = item
            await axios.get(`${url}/chat/messages/${item.quote.id}?expand=owner`, config).then((response) => {
              messageList.push({
                ...parentMessage,
                quote: {
                  ...response.data.data
                }
              })
            }).catch(error => {
              console.log('Ошибка получения сообщения для цитаты', error)
            })
          } else {
            messageList.push(item)
          }
        }
      }
      processMessages(response.data.data).then(() => {
        commit('GET_DIALOG_ROOM_MESSAGE_LIST', messageList)

        const paginationData = {
          currentPage: response.headers['x-pagination-current-page'],
          pageCount: response.headers['x-pagination-page-count']
        }
        commit('SET_DIALOG_ROOM_MESSAGE_LIST_PAGINATION', paginationData)
      })
    }).catch(error => {
      console.log('Ошибка получения сообщений диалога', error)
    })
  },
  getDialogRoomMessageListNextPage ({ commit, state }) {
    const sort = 'sort=-id'
    const expands = 'expand=owner,room,attachments,quote,forwarded_messages'
    const filter = `search[room_id]=${state.currentDialog.id}`
    const nextPage = ++state.currentPage
    const pageCount = state.pageCount

    if (nextPage <= pageCount) {
      commit('SET_DIALOG_ROOM_NEXT_PAGE_IS_LOADING')

      axios.get(`${url}/chat/messages?${sort}&${expands}&${filter}&page=${nextPage}`, config).then(response => {
        const messageList = []
        async function processMessages (array) {
          for (const item of array) {
            if (item.quote) {
              const parentMessage = item
              await axios.get(`${url}/chat/messages/${item.quote.id}?expand=owner`, config).then((response) => {
                messageList.push({
                  ...parentMessage,
                  quote: {
                    ...response.data.data
                  }
                })
              }).catch(error => {
                console.log('Ошибка получения сообщения для цитаты', error)
              })
            } else {
              messageList.push(item)
            }
          }
        }
        processMessages(response.data.data).then(() => {
          commit('GET_DIALOG_ROOM_MESSAGE_LIST_NEXT_PAGE', messageList)
          commit('UPDATE_DIALOG_DATE_BREAKERS')
          const paginationData = {
            currentPage: response.headers['x-pagination-current-page'],
            pageCount: response.headers['x-pagination-page-count']
          }
          commit('SET_DIALOG_ROOM_MESSAGE_LIST_PAGINATION', paginationData)
        })
      }).catch(error => {
        console.log('Ошибка получения новой страницы сообщений диалога', error)
      })
    }
  },
  setDialogMessageListIsRead ({ state, rootState }) {
    const currentUserId = rootState.appData?.currentUser?.id
    const unReadMessages = state.currentDialog?.messages?.map(item => {
      // фильтрануть уже прочитанные и свои
      return !item.is_dateBreaker && !item.is_read && item.owner.id !== currentUserId ? item.id : null
    }).filter(item => item !== null)

    const channel = state.currentDialog?.channel
    const publishData = {
      room_id: state.currentDialog?.id,
      message_ids: unReadMessages,
      is_read: true
    }

    // флаг is_read всех видимых сообщений меняется на true, когда хотя бы один юзер комнаты сфокусировался на поле ввода
    if (unReadMessages && unReadMessages?.length !== 0) {
      let successCounter = 0

      unReadMessages.forEach(messageId => {
        const updateData = {
          id: messageId,
          is_read: true
        }
        axios.put(`${url}/chat/messages/${updateData.id}/read`, updateData, config).then(() => {
          // счетчик успешных ответов нужен чтобы один раз иницировать обновление сообщений для других пользователей,
          // а не делать этого при каждом успешном редактировании одного сообщения
          ++successCounter
          if (successCounter === unReadMessages?.length) {
            centrifugePublish(channel, 'update-messages', publishData)
          }
        }).catch(error => {
          console.log(`ошибка пометки сообщения как прочитанного id: ${messageId}`, error.response.data)
        })
      })
    }
  },
  getDialogUserList ({ dispatch, commit, state, rootState }, page) {
    const currentUserId = rootState.appData.currentUser.id

    // нужно фильтрануть юзеров убрав себя
    const filteredUsers = (users) => {
      return users.filter(user => user.id !== currentUserId)
    }

    const params = {
      filterData: '',
      searchFilter: state.dialogRoomList.searchValue ? `search[all]=${state.dialogRoomList.searchValue}` : '',
      currentTake: 20,
      currentPage: !page ? state.dialogRoomList.userListPagination.currentPage : page
    }

    // TODO: Если фильтрация по юзерам тут будет плохо работать, то можно добавить на беке специальный поиск, который будет исключать юзеров уже участвующих в приватных чатах
    usersApi.getAll(params).then(response => {
      if (!page) {
        commit('SET_DIALOG_WIDGET_USER_LIST', filteredUsers(response.data.data))
      } else {
        commit('SET_DIALOG_WIDGET_USER_LIST_NEXT_PAGE', filteredUsers(response.data.data))
        commit('SET_DIALOG_WIDGET_USER_LIST_PAGINATION', response.headers)
      }
      dispatch('updateDialogUserList') // нужно обновлять список юзеров для которых можно создать приватный диалог
    }).catch(error => {
      console.log('ошибка получения списка юзеров для виджета чата', error.response ? error.response : error)
    })
  },
  updateDialogUserList ({ commit, state }) {
    const dialogUserList = [...state.dialogRoomList.userList]
    const existingPrivateDialogsUserIds = []

    // массив айдишников юзеров, для которых уже создани приватный чат нужен для дальнейшего сравнения
    state.dialogRoomList.list.forEach(dialog => {
      if (!dialog.is_group) {
        dialog.users.forEach(user => {
          existingPrivateDialogsUserIds.push(user.id)
        })
      }
    })

    // фильруем контакты чтобы убрать юзеров для которых приватный чат уже существует
    const filteredUsers = (users) => {
      return users.filter(user => !existingPrivateDialogsUserIds.includes(user.id))
    }

    commit('SET_DIALOG_WIDGET_USER_LIST', filteredUsers(dialogUserList))
  },
  updateDialogRoomLastMessage ({ state, commit }, data) {
    const dialogRoom = state.dialogRoomList.list.find(room => {
      return room.id === data.room_id
    })

    if (dialogRoom) {
      const sort = 'sort=-id'
      const filter = `search[room_id]=${dialogRoom.id}`

      axios.get(`${url}/chat/messages?${sort}&${filter}&per-page=1`, config).then(response => {
        dialogRoom.lastMessage = response.data?.data[0]?.message ? clearUserHtml(response.data.data[0].message, true) : null
      }).catch(error => {
        console.log('ошибка обновления последнего сообщения диалога в списке комнат', error)
      })
    }
  },
  createPrivateDialog ({ dispatch, commit, state, rootState }, user) {
    // создание приватного чата (таже комната только с двумя участниками)
    const postData = {
      name: 'private',
      color: null,
      user_ids: [user.id],
      type: 1
    }

    commit('SET_DIALOG_ROOM_LOADING', true)
    axios.post(`${url}/chat/rooms`, postData, config).then((response) => {
      const roomId = response.data.data.id
      const currentUserId = rootState.appData.currentUser.id
      const expandUserIds = [...postData.user_ids, currentUserId]

      centrifugePublish('channel_system', 'system_update-room-list', { room_users: expandUserIds })
      // быстрый фикс чтобы сразу включить созданный чат, таймаут нужен чтобы список чатов успел обновиться
      // иначе на этот чат не повиснит is_active и он не будет подсвечиваться как активный
      setTimeout(() => {
        dispatch('setActiveDialog', roomId)
      }, 0)
    }).catch(error => {
      const roomId = error.response?.data?.data?.message
      if (roomId && typeof roomId === 'number') {
        dispatch('setActiveDialog', roomId)
      }
      console.log('Ошибка создания приватного чата', error.response)
    })
  },

  // модалка комнаты чата
  showDialogDeleteModal ({ commit }, roomId) {
    commit('SHOW_DIALOG_DELETE_MODAL', roomId)
  },
  showDialogRoomModal ({ commit }, roomId) {
    commit('SHOW_DIALOG_ROOM_MODAL', roomId)
  },

  addDialogRoomModalMember ({ commit }, user) {
    commit('ADD_DIALOG_ROOM_MODAL_MEMBER', user)
  },
  removeDialogRoomModalMember ({ commit }, user) {
    commit('REMOVE_DIALOG_ROOM_MODAL_MEMBER', user)
  },
  closeDialogRoomModal ({ commit }) {
    commit('CLOSE_DIALOG_ROOM_MODAL')
  },
  // /модалка комнаты чата

  // модалка стории сообщений
  showDialogHistoryModal ({ commit }) {
    commit('SHOW_DIALOG_HISTORY_MODAL')
  },
  loadDialogHistoryModalMessages ({ commit, state }) {
    const sort = 'orderBy=created_at&orderDir=DESC'
    const expands = 'expand=owner,room,attachments,quote,forwarded_messages'
    const filter = `search[room_id]=${state.currentDialog.id}`

    axios.get(`${url}/chat/messages?per-page=1`, config).then(response => {
      // запрашиваем по минималке чтобы получить headers и затем запросить все имеющиеся сообщения
      axios.get(`${url}/chat/messages?${sort}&${expands}&${filter}&per-page=${response.headers['x-pagination-total-count']}`, config).then(response => {
        // нужно пройтись по полученным сообщениям и если есть quote (сообщение на которое отвечали)
        // то запросить его по id, чтобы получить owner. owner нужен для вывода в сообщении его фио
        // проходка по массиву должна быть ассинхронной, иначе сообщения уже отрисуются прежде чем будет получен ответ от сервера
        const messageList = []
        async function processMessages (array) {
          for (const item of array) {
            if (item.quote) {
              const parentMessage = item
              await axios.get(`${url}/chat/messages/${item.quote.id}?expand=owner`, config).then((response) => {
                messageList.push({
                  ...parentMessage,
                  quote: {
                    ...response.data.data
                  }
                })
              }).catch(error => {
                console.log('Ошибка получения сообщения для цитаты (история сообщений)', error)
              })
            } else {
              messageList.push(item)
            }
          }
        }
        processMessages(response.data.data).then(() => {
          commit('GET_DIALOG_HISTORY_MODAL_MESSAGES', messageList)
        })
      }).catch(error => {
        console.log('Ошибка получения полного списка сообщений (история сообщений)', error)
      })
    })
  },
  // /модалка стории сообщений

  toggleCurrentDialogControls ({ commit }) {
    commit('TOGGLE_CURRENT_DIALOG_CONTROLS')
  },
  closeDialogWidget ({ commit }) {
    commit('CLOSE_ASIDE_DIALOG_WIDGET')
  },
  closeAllDialogWidgetPopups ({ commit }) {
    commit('CLOSE_CURRENT_DIALOG_CONTROLS')
    commit('CLOSE_DIALOG_MESSAGE_CONTROLS')
  },
  toggleDialogMessageControls ({ commit }, messageId) {
    commit('TOGGLE_DIALOG_MESSAGE_CONTROLS', messageId)
  },
  setDialogMessageValue ({ commit, state, rootState }, message) {
    const dialog = state.currentDialog
    const publishData = {
      room_id: dialog.id,
      user_id: rootState.appData.currentUser?.id
    }

    centrifugePublish(dialog.channel, 'user-prints-message', publishData)
    commit('SET_DIALOG_MESSAGE_VALUE', message)
  },
  dialogMessageAttachFiles ({ commit }, files) {
    commit('DIALOG_MESSAGE_ATTACH_FILES', files)
  },
  dialogMessageRemoveFile ({ commit }, data) {
    commit('DIALOG_MESSAGE_REMOVE_FILE', data)
  },
  dialogMessageToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_DIALOG_MESSAGE_LINK_TOOLTIP')
    commit('CLOSE_DIALOG_MESSAGE_TAG_TOOLTIP')
  },
  dialogMessageCloseLinkTooltip ({ commit }) {
    commit('CLOSE_DIALOG_MESSAGE_LINK_TOOLTIP')
  },
  dialogMessageSetLinkText ({ commit }, text) {
    commit('SET_DIALOG_MESSAGE_LINK_TEXT', text)
  },
  dialogMessageSetLinkUrl ({ commit }, url) {
    commit('SET_DIALOG_MESSAGE_LINK_URL', url)
  },
  dialogMessageAttachLink ({ commit, state }) {
    const text = state.messageArea.attachment.linkTooltip.text
    const url = state.messageArea.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_DIALOG_MESSAGE_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_DIALOG_MESSAGE_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_DIALOG_MESSAGE_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  dialogMessageToggleTagTooltip ({ commit }) {
    commit('TOGGLE_DIALOG_MESSAGE_TAG_TOOLTIP')
    commit('CLOSE_DIALOG_MESSAGE_LINK_TOOLTIP')
  },
  dialogMessageCloseTagTooltip ({ commit }) {
    commit('CLOSE_DIALOG_MESSAGE_TAG_TOOLTIP')
  },
  dialogMessageSetTagText ({ commit }, text) {
    commit('SET_DIALOG_MESSAGE_TAG_TEXT', text)
  },
  dialogMessageAttachTag ({ commit, state }) {
    if (state.messageArea.attachment.tagTooltip.text) {
      commit('DIALOG_MESSAGE_ATTACH_TAG')
      commit('CLOSE_DIALOG_MESSAGE_TAG_TOOLTIP')
    } else {
      commit('SET_DIALOG_MESSAGE_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  dialogMessageRemoveTag ({ commit }, index) {
    commit('DIALOG_MESSAGE_REMOVE_TAG', index)
  },
  dialogMessageAttachmentClearValidation ({ commit }) {
    commit('CLEAR_DIALOG_MESSAGE_ATTACHMENT_VALID')
  },
  cancelDialogMessageUpdate ({ commit }) {
    commit('CLEAR_DIALOG_MESSAGE_AREA')
  },

  sendDialogMessage ({ commit, state, getters, rootState }) {
    if (
      !state.messageArea.resendMessages.length &&
      !state.messageArea.message &&
      !state.messageArea?.attachment?.files?.length
    ) {
      return
    }

    commit('SET_SEND_MESSAGE_LOADING', true)
    const message = state.messageArea.message
    const forwarded_messages = []

    state.messageArea.resendMessages.map(resendMessage => {
      forwarded_messages.push(resendMessage.id)
    })
    
    const files = state.messageArea.attachment.files
    const updatedId = state.messageArea.updatedId
    const reply = state.messageArea.reply
    const channel = state.currentDialog.channel
    const roomId = state.currentDialog.id
    const currentUserId = rootState.appData.currentUser.id
    let tags = state.messageArea.attachment.tags.join('&tags[]=')
    tags = tags.length !== 0 ? 'tags[]=' + tags : ''

    // создание сообщения
    const messageData = {
      message: clearUserHtml(message, false),
      chat_room_id: roomId,
      // для установки связи "цитата/ответ" отправляем message_id
      // тогда в созданном сообщение появится поле quote, которое содержит связанное сообщение
      message_id: reply.id,
      forwarded_messages: forwarded_messages
    }

    const formData = new FormData()

    // создание временного сообщения для отображения в чате с индикатором загрузки
    const beforeSendData = {
      attachments: files || [],
      created_at: formatDateForServer(new Date()),
      id: `before-send-${state.currentDialog.messages.length + 1}`,
      isControlsActive: false,
      is_dateBreaker: false,
      is_read: false,
      isSending: true,
      message: messageData.message,
      owner: { ...getters.currentUserData },
      quote: getters.getQuote,
      readers: null,
      room: { id: roomId },
      status: 1,
      tags: tags || []
    }

    commit('ADD_MESSAGE_BEFORE_SEND', beforeSendData)

    if (!updatedId) {
      // отправка нового сообщения
      for (let i = 0; i < files.length; ++i) {
        formData.append('files[]', files[i])
      }

      axios.post(`${url}/chat/messages?${tags}`, messageData, config)
        .then((response) => {
          commit('CLEAR_DIALOG_MESSAGE_AREA')
          const messageId = response.data.data.id

          if (files.length !== 0) {
            axios.post(`${url}/chat/messages/${messageId}/files`, formData, configMultipart)
              .then(response => {
                centrifugePublish(channel, 'update-messages', { room_id: roomId, is_new: true, user_id: currentUserId })
              })
              .catch(error => {
                console.log('Ошибка прикрепления файлов после создания приложения', error.response)
              })
          } else {
            centrifugePublish(channel, 'update-messages', { room_id: roomId, is_new: true, user_id: currentUserId })
          }
        })
        .catch(error => {
          console.log('Ошибка отправки сообщения', error.response)
          commit('SET_DIALOG_MESSAGE_AREA_ERROR', error.response.data.validation)
        })
        .finally(() => commit('SET_SEND_MESSAGE_LOADING', false))
    } else {
      // редактирование сообщения
      // выбираем только вновь добавленные файлы у которых нет id чтобы не заливать дубли на серв
      const newFiles = files.filter(file => {
        return file.id === undefined
      })
      for (let i = 0; i < newFiles.length; ++i) {
        formData.append('files[]', newFiles[i])
      }

      const removeMessageFiles = state.messageArea.attachment.filesToRemove.map(id => {
        return axios.delete(`${url}/files/${id}`, config)
      })
      const attachNewFiles = newFiles.length !== 0 ? axios.post(`${url}/chat/messages/${updatedId}/files`, formData, configMultipart) : false
      const updateMessageData = axios.put(`${url}/chat/messages/${updatedId}?${tags}`, messageData, config)

      axios.all([removeMessageFiles, attachNewFiles, updateMessageData]).then(response => {
        commit('CLEAR_DIALOG_MESSAGE_AREA')
        centrifugePublish(channel, 'update-messages', { room_id: roomId, is_updated: updatedId })
      }).catch(error => {
        if (error.response.status === 422) {
          commit('SET_DIALOG_MESSAGE_AREA_ERROR', error.response.data.errors)
        } else if (error.response.status === 406) {
          commit('SET_DIALOG_MESSAGE_AREA_ERROR', { message: [error.response.data.data] })
        }
        console.log('Ошибка отправки сообщения', error.response.data)
      }).finally(() => commit('SET_SEND_MESSAGE_LOADING', false))
    }
  },
  // после того как сообщение было успешно отредактировано и пришел триггер из центрифуги, вызывается этот экшон
  // для того чтобы запросить редактирвоанное сообщение по id и заменить его в массиве сообщений в стейте
  // это позволяет избежать полного обновления списка сообщений и сброса пагинации

  updateDialogRoomMessage ({ commit, state }, messageData) {
    // для экономии проверяем совпадает ли активный диалог с тем в котором редачим сообщение, иначе это не имеет смысла
    // и отредактированное сообщение юзер получит при активации диалога
    if (state.currentDialog && state.currentDialog.id === messageData.roomId) {
      const expands = 'expand=owner,attachments,quote'
      const filter = `search[room_id]=${messageData.roomId}`

      axios.get(`${url}/chat/messages/${messageData.messageId}?${expands}&${filter}`, config).then((response) => {
        let responseData = response.data.data

        if (responseData.quote) {
          axios.get(`${url}/chat/messages/${responseData.quote.id}?expand=owner`, config).then((response) => {
            responseData = {
              ...responseData,
              quote: {
                ...response.data.data
              }
            }
            commit('UPDATE_DIALOG_ROOM_MESSAGE', responseData)
          }).catch(error => {
            console.log('Ошибка получения сообщения для цитаты', error)
          })
        } else {
          commit('UPDATE_DIALOG_ROOM_MESSAGE', responseData)
        }
      }).catch(error => {
        console.log('Ошибка получения отредактированного сообщения', error.response.data)
      })
    }
  },
  setActiveDialog ({ commit }, roomId) {
    // открываем виджет если диалог был открыт из aside (недавние диалоги)
    commit('OPEN_ASIDE_DIALOG_WIDGET')
    commit('CLEAR_DIALOG_MESSAGE_AREA')

    const expands = 'expand=users,pinned_message,owner,admins'

    commit('SET_DIALOG_ROOM_LOADING', true)
    axios.get(`${url}/chat/rooms/${roomId}?${expands}`, config).then((response) => {
      const responseData = response.data.data
      commit('SET_ACTIVE_DIALOG_ROOM', responseData)
      this.dispatch('getDialogRoomMessageList', responseData.id)

      if (responseData.pinned_message) {
        // нужно получить доп данный для закрепленного сообщения, которые не приходят сразу (файлы, владелец)
        const expands = 'expand=owner,attachments'
        axios.get(`${url}/chat/messages/${responseData.pinned_message.id}?${expands}`, config).then(response => {
          commit('EXPAND_ACTIVE_DIALOG_PINNED_MESSAGE', response.data.data)
        })
          .catch(error => {
            console.log('Ошибка получения закрепленного сообщения диалога', error)
          })
      }
    }).catch(error => {
      console.log('Ошибка получения группового чата и установки его как текущего', error.data)
    }).finally(() => commit('SET_DIALOG_ROOM_LOADING', false))
  },
  removeDialog ({ commit }, dialogData) {
    commit('CLOSE_DIALOG_DELETE_MODAL')
    axios.delete(`${url}/chat/rooms/${dialogData.id}`, config).then((response) => {
      centrifugePublish('channel_system', 'system_update-room-list', { room_users: dialogData.users, is_removed: true })
    }).catch(error => {
      console.log('Ошибка удаления группового чата', error.response.data)
    })
  },

  pinDialogMessage ({ commit, state }, messageId) {
    const channel = state.currentDialog.channel
    const roomId = state.currentDialog.id

    axios.put(`${url}/chat/messages/${messageId}/pin`, {}, config).then((response) => {
      centrifugePublish(channel, 'update-room', { room_id: roomId, is_pinned: messageId })
    }).catch(error => {
      console.log('Ошибка закрепления сообщения', error.response.data)
    })
  },
  unPinDialogMessage ({ commit, state }) {
    const messageId = state.currentDialog.pinned_message.id
    const channel = state.currentDialog.channel
    const roomId = state.currentDialog.id

    axios.put(`${url}/chat/messages/${messageId}/unpin`, {}, config).then((response) => {
      centrifugePublish(channel, 'update-room', { room_id: roomId, is_pinned: null })
    }).catch(error => {
      console.log('Ошибка открепления сообщения', error.response.data)
    })
  },
  updateDialogRoomPinnedMessage ({ commit }, pinData) {
    if (pinData.messageId) {
      const expands = 'expand=attachments'

      axios.get(`${url}/chat/messages/${pinData.messageId}?${expands}`, config).then((response) => {
        commit('PIN_DIALOG_ROOM_MESSAGE', response.data.data)
      }).catch(error => {
        console.log('Ошибка получения сообщения для закрепления', error.response.data)
      })
    } else {
      commit('UNPIN_DIALOG_ROOM_MESSAGE')
    }
  },
  getDialogMessageForUpdate ({ commit }, message) {
    commit('GET_DIALOG_MESSAGE_FOR_UPDATE', message)
  },
  replyDialogMessage ({ commit }, data) {
    commit('SET_DIALOG_MESSAGE_REPLY', data)
  },
  unReplyDialogMessage ({ commit }) {
    commit('REMOVE_DIALOG_MESSAGE_REPLY')
  },
  removeDialogMessage ({ commit, state }, messageId) {
    const roomId = state.currentDialog.id
    const channel = state.currentDialog.channel

    axios.delete(`${url}/chat/messages/${messageId}`, config).then((response) => {
      commit('REMOVE_DIALOG_MESSAGE', messageId)
      commit('UPDATE_DIALOG_DATE_BREAKERS')
      // оповещаем других участников что сообщение удалено
      centrifugePublish(channel, 'update-messages', { room_id: roomId, removed_id: messageId })
    }).catch(error => {
      console.log('Ошибка удаления сообщения чата', error)
    })
  },

  // search
  setDialogListSearchValue ({ state, dispatch, commit }, value) {
    commit('SET_DIALOG_LIST_SEARCH_VALUE', value)

    // сбрасываем пагинацию чтобы результаты поиска отображался с первой страницы
    commit('RESET_DIALOG_WIDGET_USER_LIST_CURRENT_PAGE')
    if (value) {
      commit('SET_DIALOG_WIDGET_USER_LIST_PAGINATION_BLOCK', true)
    } else {
      commit('SET_DIALOG_WIDGET_USER_LIST_PAGINATION_BLOCK', false)
    }

    if (!state.debounce) {
      commit('SET_DEBOUNCE', debounce(function () {
        dispatch('getDialogUserList')
        // false передаём для того чтобы обозначить что переподписываться на каналы в этом случае не нужно
        // поиск по комнатам пока отключен, потому что работает некорректно, имена у всех приватных чатов private поэтому поиск их не учитывает
        dispatch('getDialogRoomList', { needSubscribe: false, updateCurrent: false })

        commit('SET_DEBOUNCE', null)
      }, 500))

      state.debounce()
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}

// TODO: поиск по названию группы
// TODO: сделать задержку на запрос по вводу в строку поиска
